import { useEffect } from "react";

export function useClassicRoomSocket(
  socket,
  roomName,
  setNumPrompts,
  setWaitingForPrompts,
  setGameStarted,
  setInGameLength,
) {
  useEffect(() => {
    const onRoomState = (msg) => {
      setNumPrompts(msg.promptCount);
      if (setGameStarted) setGameStarted(msg.gameStarted);
      if (setInGameLength) setInGameLength(msg.inGameLength ?? 0);
    };
    const onWaiting = () => setWaitingForPrompts(true);
    const onStopWaiting = () => setWaitingForPrompts(false);

    socket.on("classic room state", onRoomState);
    socket.on("waitingForPrompts", onWaiting);
    socket.on("stopWaitingForPrompts", onStopWaiting);

    socket.emit("join room", roomName);

    return () => {
      socket.off("classic room state", onRoomState);
      socket.off("waitingForPrompts", onWaiting);
      socket.off("stopWaitingForPrompts", onStopWaiting);
    };
  }, [
    socket,
    roomName,
    setNumPrompts,
    setWaitingForPrompts,
    setGameStarted,
    setInGameLength,
  ]);
}
